import { SxProps, Theme } from '@mui/material'

export const PANEL_ACTION_GAP = '8px'

export const panelActionButtonSx: SxProps<Theme> = {
  margin: 0,
  padding: '2px 10px',
  minHeight: '28px',
  minWidth: 0,
  fontSize: '12px',
  lineHeight: 1.2,
  textTransform: 'uppercase',
  '& .MuiButton-startIcon': {
    marginRight: '6px',
    '& > svg': { fontSize: '16px' },
  },
}
